import { Injectable, inject, Injector } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {ActivateTrialLicenseActionTypes, ActivateTrialLicenseActions} from '../actions/activate-trial-license.actions';
import {catchError, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {LicenseMgtService} from '../../../services/license-mgt.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {UpdateInfoModel} from '../../updateInfo/update-info.model';
import {licenseMap, updateInfoType} from '../../../shareModel';
import {of} from 'rxjs';
import * as featureActions from '../../index';
import {TranslateService} from '@ngx-translate/core';



@Injectable()
export class ActivateTrialLicenseEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private licenseMgtService = inject(LicenseMgtService);
  private injector = inject(Injector);


  constructor() {}

  GetActivateTrialLicenses$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.ActivateTrialLicenseActionTypes.GetActivateTrialLicense),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const payload = { ...action.payload, otp: user.otp };
      return this.licenseMgtService.ActivateTrialLicense(payload).pipe(
        map((res: any) => {
          const updateRes: UpdateInfoModel = {
            result: false,
            msg: '',
            errmsg: 'Error',
            type: updateInfoType.ActivateTrialLicense
          };
          if (res.result && res.msg.body === 0) {
            return new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true, msg: this.injector.get(TranslateService).instant('Update Success') });
          } else {
            // const data = res.msg.body;
            return new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: this.injector.get(TranslateService).instant('Update Failed') });
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const updateRes: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.ActivateTrialLicense
          };
          return of(new featureActions.UpdateInfoFailAction(updateRes));
        })
      );
    })
  ));
}
